module.exports = __webpack_public_path__ + "img/erp_main.972e05cd.png";